// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baxDG {
  position: relative;
  width: 100%;
}
.baxDG .AUa59 {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s ease;
}
.baxDG .AUa59:focus {
  border-color: #577cf6 !important;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.baxDG .AUa59:hover {
  border-color: #577cf6 !important;
}
.baxDG .SvM2S {
  border-color: #577cf6 !important;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
}
.baxDG .xR2CO {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  margin-top: 4px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  max-height: 200px;
  overflow: hidden;
  padding: 8px;
}
.baxDG .xR2CO .P2Ijy {
  max-height: 200px;
  overflow-y: auto;
}
.baxDG .xR2CO .P2Ijy::-webkit-scrollbar {
  width: 6px;
}
.baxDG .xR2CO .P2Ijy::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.baxDG .xR2CO .P2Ijy::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.baxDG .xR2CO .P2Ijy::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.baxDG .xR2CO .lNEpR {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.5;
  color: #333333;
  transition: all 0.2s ease;
  word-break: break-word;
  border-radius: 8px;
  margin-bottom: 4px;
}
.baxDG .xR2CO .lNEpR:last-child {
  margin-bottom: 0;
}
.baxDG .xR2CO .lNEpR:hover,
.baxDG .xR2CO .lNEpR.T9h73 {
  background-color: #F7F8FF;
}
.baxDG .xR2CO .lNEpR:active {
  background-color: #F7F8FF;
}
.baxDG .xR2CO .lNEpR .Sd16W {
  color: #567BF4;
  font-weight: 500;
}
.baxDG .cURsl {
  padding: 16px 12px;
  text-align: center;
  color: #999;
  font-size: 14px;
}
.baxDG .Sk9Y_ {
  padding: 16px 12px;
  text-align: center;
  color: #999;
  font-size: 14px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectSearch": `baxDG`,
	"selectSearchInput": `AUa59`,
	"showDropdownInput": `SvM2S`,
	"dropdown": `xR2CO`,
	"dropdownList": `P2Ijy`,
	"dropdownItem": `lNEpR`,
	"focused": `T9h73`,
	"highlight": `Sd16W`,
	"noResults": `cURsl`,
	"loading": `Sk9Y_`
};
export default ___CSS_LOADER_EXPORT___;
